export enum ALL_KINDS {
    'PX' = 'PX',
    LAB_TESTS_KIND = 'LAB_TESTS_KIND',
    MEDICINES_KIND = 'MEDICINES_KIND',
    DIAGNOSIS_KIND = 'DIAGNOSIS_KIND',
    SYMPTOMS_KIND = 'SYMPTOMS_KIND',
    LAB_VITALS_KIND = 'LAB_VITALS_KIND',
    EXAMINATIONS_KIND = 'EXAMINATIONS_KIND',
    INJECTIONS_KIND = 'INJECTIONS_KIND',
    PROCEDURES_KIND = 'PROCEDURES_KIND',
}

export enum INJECTION_COLUMN {
    DRUG = 'INJECTION',
    DOSE = 'DOSE',
    ROUTE = 'ROUTE',
    INFUSION_RATE = 'INFUSION_RATE',
    FREQUENCY = 'FREQUENCY',
    TIMING = 'TIMING',
    DURATION = 'DURATION',
    INSTRUCTIONS = 'INSTRUCTIONS',
}

export enum LAB_TESTS_COLUMN {
    REPEAT_ON = 'repeat_on',
    TEST_ON = 'test_on',
    REMARK = 'remark'
}
